import scrollTo from "@/utils/scrollTo";
import {
  ArrowRight,
  BrainCircuit,
  Cpu,
  Grid2X2,
  Handshake,
  Star,
  Wrench,
} from "lucide-react";
import Button from "../ui/button";

export default function GameChanger() {
  const benefits = [
    {
      icon: (
        <Grid2X2 className="ml-auto w-10 h-10 stroke-1 text-primaryLight group-hover:text-white role-icon" />
      ),
      name: "Flexibility",
      description:
        "Every creator’s journey is different. EnfiniTask offers adaptable solutions from editing and design to analytics and community management, giving you the flexibility to scale on your terms.",
    },
    {
      icon: (
        <Star className="ml-auto w-10 h-10 stroke-1 text-primaryLight group-hover:text-white role-icon" />
      ),
      name: "Expertise",
      description:
        "With years of experience supporting creators, agencies, and media brands, our team understands the platforms, trends, and strategies that drive digital growth. ",
    },
    {
      icon: (
        <BrainCircuit className="ml-auto w-10 h-10 stroke-1 text-primaryLight group-hover:text-white role-icon" />
      ),
      name: "Excellence",
      description:
        "We’re dedicated to helping you maximize your reach, impact, and revenue. EnfiniTask has built a reputation for delivering consistent, high-quality support that creators and teams can rely on.",
    },
    {
      icon: (
        <Cpu className="ml-auto w-10 h-10 stroke-1 text-primaryLight group-hover:text-white role-icon" />
      ),
      name: "Innovation",
      description:
        "We combine creative talent with intuitive task management tools that streamline collaboration, ensure transparency, and protect the security of your content.",
    },
    {
      icon: (
        <Handshake className="ml-auto w-10 h-10 stroke-1 text-primaryLight group-hover:text-white role-icon" />
      ),
      name: "Partnerships",
      description:
        "Think of us as an extension of your team. We invest in long-term partnerships, providing reliable talent and ongoing support so you can build sustainably and stay ahead in the creator economy.",
    },
    {
      icon: (
        <Wrench className="ml-auto w-10 h-10 stroke-1 text-primaryLight group-hover:text-white role-icon" />
      ),
      name: "Solutions",
      description:
        "From quick creative tasks to full-scale growth support, EnfiniTask adapts to your needs at every stage. And when you need something unique, we’ll design a custom solution tailored to your goals.",
    },
  ];

  return (
    <div className="lg:py-10 mx-auto w-[90%] space-y-12 md:space-y-20 4xl:max-w-[100rem]">
      <div className="space-y-8 text-center lg:text-left">
        <h1 className="text-4xl md:text-5xl text-primaryLight">
          Why Task is a game changer?
        </h1>
        <p className="text-[#EDE9FE] max-w-3xl text-sm md:text-lg">
          EnfiniTask empowers creators, agencies, and media brands with the
          talent, tools, and systems they need to scale faster. From day-to-day
          creative tasks to long-term growth strategies, we provide flexible,
          high-quality solutions tailored to the creator economy.
        </p>
        <Button
          className="group relative rounded-full shadow bg-primary text-white py-6 hidden mx-auto lg:mx-0 md:flex items-center justify-center gap-2 overflow-hidden hover:text-primary hover:bg-white"
          onClick={() => scrollTo("difference")}
        >
          <span className="transform transition-transform duration-300 group-hover:translate-x-5">
            See the difference
          </span>
          <ArrowRight className="transform transition-transform duration-300 group-hover:-translate-x-[128px]" />
        </Button>
      </div>
      <div className="flex overflow-x-auto gap-4 md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-4 scrollbar-hide">
        {benefits.map((benefit, index) => (
          <div
            key={index}
            className="group relative bg-[#161616] border border-[#434242] rounded-[20px] p-5 w-full h-48 lg:h-48 flex-shrink-0 overflow-hidden hover:bg-primary transition-colors duration-300 role-card"
          >
            <div className="absolute top-5 right-5">{benefit.icon}</div>

            <div
              className={`absolute bottom-5 left-5 right-5 transition-all duration-500 group-hover:bottom-[133px]`}
            >
              <h1 className="text-2xl text-primaryLight transition-all duration-500 group-hover:text-white">
                {benefit.name}
              </h1>
            </div>

            <p className="absolute left-5 right-5 bottom-5 text-sm lg:text-[12px] xl:text-sm text-[#EDE9FE] opacity-0 group-hover:opacity-100 transition-opacity duration-500 group-hover:bottom-5">
              {benefit.description}
            </p>
          </div>
        ))}
      </div>

      <Button
        className="group relative rounded-full shadow bg-primary text-white py-6 flex items-center justify-center gap-2 overflow-hidden hover:text-primary hover:bg-white mx-auto md:hidden"
        onClick={() => scrollTo("difference")}
      >
        <span className="transform transition-transform duration-300 group-hover:translate-x-5">
          See the difference
        </span>
        <ArrowRight className="transform transition-transform duration-300 group-hover:-translate-x-[128px]" />
      </Button>
    </div>
  );
}
